// extracted by mini-css-extract-plugin
export default {"noCampaignsContainer":"MyCampaigns_noCampaignsContainer__41EzH"};